module.exports = __webpack_public_path__ + "img/023.4369c503.png";